import {
	Toolbar as ToolbarMui,
} from '@mui/material';
import { ChildrenProps, appendClassName } from '@componentLibraryWrapper/common';
import './toolbar.scss';

export interface ToolbarProps extends ChildrenProps<HTMLDivElement> {
}

const Toolbar = ({
	className,
	...rest
}: ToolbarProps) => {
	return (
		<ToolbarMui 
			{...rest}
			className={appendClassName('sm-toolbar', className)} />
	)
}

export default Toolbar;